import { Link, NavItem } from "@menu/core/types";
import MenuContext, { DisplayItem } from "@menu/core/menu.context";
import { useOpenLink } from "@menu/core/hooks";
import environment from "@menu-environment";

const searchCssName = "search-open";

const useMenuActions = (context: MenuContext) => {
    const openLink = useOpenLink(context);

    const showChannels = (display: boolean) => {
        if (display && context.selectedArea) {
            context.clearArea();
        }

        const toDisplay = display ? DisplayItem.Channels : DisplayItem.MainNav;

        context.updateDisplayItem(toDisplay);
    }

    const showSearch = () => {
        context.updateDisplayMobileNav(false);
        context.updateDisplayItem(DisplayItem.Search);
        document.body.classList.add(searchCssName)
    }

    const closeSearch = () => {
        context.updateDisplayItem(DisplayItem.MainNav)
        document.body.classList.remove(searchCssName)
    }

    const selectHeaderLink = (e: any, item: NavItem) => {
        if (context.isDesktop && context.selectedArea === item && context.displaySubMenu) {
            context.clearArea();
            return;
        }

        const hasChildItems = (item.subnavItems?.length ?? 0) > 0;
        const hasLink = (item.link && !item.link.startsWith("#")) || (item.link.startsWith("#/") && !environment.production);

        let gotoLink = hasLink && !hasChildItems;

        if (!gotoLink && hasLink && hasChildItems) {
            gotoLink = !context.isMobile;
        }

        if (gotoLink) {
            context.clearArea();

            openLink(e, item as Link, context);

            if (context.isMobile) {
                context.updateDisplayMobileNav(false);
            }
            return;
        }

        if (!hasChildItems) {
            return;
        }

        let wait = 0;

        if (context.selectedArea) {
            context.clearArea();
            wait = 100;
        }

        setTimeout(() => {
            context.updateArea(item);
            context.updateDisplayItem(DisplayItem.SubNav);
        }, wait);
    }

    return { showChannels, showSearch, closeSearch, selectHeaderLink };
}

export default useMenuActions;